import React from 'react';
import Image from 'next/legacy/image';
import classNames from 'classnames';
import styles from './CollectionTutorialPopup.module.css';
import ButtonAccent from '../../sharedComponents/Button/ButtonAccent';

const typeTitle = (
  <p>
    1. Type
    {' '}
    <code>/collection</code>
    {' '}
    to add a list of items
  </p>
);

const introMiddle = (
  <div className={styles.doneMiddle}>
    <div className="is-subtitle mb-3">
      What is a Collection (CMS)?
    </div>
    <div className="with-text-color is-size-5 mb-2">
      Collection allows you to
      {' '}
      <strong>connect a table</strong>
      {' '}
      and
      {' '}
      <strong>show your list of items</strong>
      .
    </div>
    <img
      src="/images/cms.png"
      alt="Collection"
      className={classNames(styles.video, 'mb-2')}
    />
  </div>
);

const doneMiddle = (
  <div className={styles.doneMiddle}>
    <Image
      src="/images/tutorialMenu.png"
      width={250}
      height={200}
      objectFit="contain"
      objectPosition="left"
      className="mb-3"
    />
    <div className="is-size-4 has-text-weight-medium with-text-color mb-3">
      That&apos;s it 🎉
    </div>
    <div className="is-subtitle mb-4">
      You can open this tutorial again by clicking the Help & Resources menu.
      See the full guide to see what else you can do with Typedream!
    </div>
    <a href="https://typedream.com/docs/the-basics" target="_blank" rel="noreferrer">
      <ButtonAccent>See the guide →</ButtonAccent>
    </a>
  </div>
);

export const STEP_MAP = {
  intro: {
    key: 'intro',
    middle: introMiddle,
  },
  add: {
    key: 'add',
    title: typeTitle,
    subtitle: 'Connect your table and start showing your list of items',
    middle: <video
      controls
      muted
      autoPlay
      src="https://typedream-assets.sfo3.digitaloceanspaces.com/cms-tutorial/add.mov"
      className={styles.video}
    />,
  },
  edit: {
    key: 'edit',
    title: <p>2. Go to Categories and edit your item</p>,
    subtitle: 'Connect your table and start showing your list of items',
    middle: <video
      controls
      muted
      autoPlay
      src="https://typedream-assets.sfo3.digitaloceanspaces.com/cms-tutorial/edit.mp4"
      className={styles.video}
    />,
  },
  done: {
    key: 'done',
    middle: doneMiddle,
  },
};

export const STEPS = [STEP_MAP.intro, STEP_MAP.add, STEP_MAP.edit, STEP_MAP.done];
